<template>
  <div v-if="isVisible"
       class="fixed right-6 bottom-6 flex justify-center items-center px-3 py-2.5 rounded-zt bg-zt-more zt-hover cursor-pointer"
       @mouseleave="hideTooltip($event)"
       @click="hideTooltip($event); scroll(); countClicks(analyticName)"
       data-bs-toggle="tooltip" data-bs-placement="top" title="Wróć na górę">
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_28331_26988)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.242375 19.1907C0.165546 19.1133 0.10459 19.0214 0.0629992 18.9201C0.0214085 18.8189 -3.16999e-08 18.7103 -3.64911e-08 18.6007C-4.12824e-08 18.4911 0.0214085 18.3826 0.0629991 18.2813C0.10459 18.1801 0.165546 18.0881 0.242375 18.0107L10.1424 8.01067C10.219 7.93312 10.31 7.87156 10.4103 7.82956C10.5105 7.78756 10.618 7.7659 10.7265 7.7659C10.835 7.7659 10.9424 7.78756 11.0427 7.82956C11.1429 7.87156 11.234 7.93312 11.3105 8.01067L21.2105 18.0107C21.3655 18.1672 21.4525 18.3794 21.4525 18.6007C21.4525 18.822 21.3655 19.0342 21.2105 19.1907C21.0557 19.3472 20.8456 19.4351 20.6264 19.4351C20.4074 19.4351 20.1973 19.3472 20.0423 19.1907L10.7265 9.77906L1.41057 19.1907C1.33394 19.2683 1.2429 19.3299 1.14267 19.3719C1.04244 19.4139 0.934991 19.4355 0.826475 19.4355C0.717959 19.4355 0.610509 19.4139 0.510279 19.3719C0.41005 19.3299 0.31901 19.2683 0.242375 19.1907Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.242375 12.5247C0.165546 12.4473 0.10459 12.3553 0.0629992 12.2541C0.0214085 12.1529 -3.17e-08 12.0443 -3.64912e-08 11.9347C-4.12825e-08 11.8251 0.0214085 11.7166 0.0629991 11.6153C0.10459 11.5141 0.165546 11.4221 0.242375 11.3447L10.1424 1.34466C10.219 1.2671 10.31 1.20554 10.4103 1.16354C10.5105 1.12154 10.618 1.09988 10.7265 1.09988C10.835 1.09988 10.9424 1.12154 11.0427 1.16354C11.1429 1.20554 11.234 1.2671 11.3105 1.34466L21.2105 11.3447C21.3655 11.5012 21.4525 11.7134 21.4525 11.9347C21.4525 12.156 21.3655 12.3682 21.2105 12.5247C21.0557 12.6812 20.8456 12.7691 20.6264 12.7691C20.4074 12.7691 20.1973 12.6812 20.0423 12.5247L10.7265 3.11299L1.41057 12.5247C1.33394 12.6023 1.2429 12.6639 1.14267 12.7059C1.04244 12.7479 0.934991 12.7695 0.826475 12.7695C0.717959 12.7695 0.610509 12.7479 0.510279 12.7059C0.41005 12.6639 0.31901 12.6023 0.242375 12.5247Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_28331_26988">
          <rect width="20" height="22" fill="white" transform="translate(0 20) rotate(-90)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
import utils_mixin from '../mixins/utils_mixin';

export default {
  name: 'ScrollTop',
  inject: ['WP'],
  mixins: [utils_mixin],
  props: {
    analyticName: {
      type: String,
      required: true,
    },
    scrollToY: {
      type: Number,
      default: 0,
    },
    anchorQuery: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: false,
      refreshShowY: false,
    }
  },
  computed: {
    showY() {
      if (this.anchorQuery === '')
        return 800;

      this.refreshShowY; // Trigger odświeżający compute
      return document.querySelector(this.anchorQuery)?.getBoundingClientRect().top + window.scrollY - window.innerHeight;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollEvent);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScrollEvent);
  },
  methods: {
    handleScrollEvent() {
      this.refreshShowY = !this.refreshShowY;
      this.isVisible = window.scrollY > this.showY;
    },
    scroll() {
      window.scrollTo({ top: this.scrollToY, behavior: 'smooth' });
    },
  }
}
</script>